// Configs
import KC from "components/Stacker/config/KeyConfig"

export const getKeyCode = (key, isShift) => {
  if (isShift && key === KC.TAB) {
    return KC.BACKTAB
  }
  return key.toUpperCase()
}
